import { render } from "./TopUpList.vue?vue&type=template&id=1fa587e3&scoped=true"
import script from "./TopUpList.vue?vue&type=script&lang=js"
export * from "./TopUpList.vue?vue&type=script&lang=js"

import "./TopUpList.vue?vue&type=style&index=0&id=1fa587e3&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa587e3"]])

export default __exports__